import React, { useEffect } from 'react';
import { Container } from '@skf/bt-wind-rail-commonlibrary';
import { useLoadingScreen } from '../../../hooks/useLoadingScreen';

export const NotFound: React.FunctionComponent = () => {
  const { setLoading } = useLoadingScreen();

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Container>
      <h2>404 NotFound!!</h2>
      <br />
    </Container>
  );
};
